import React from 'react';

import { DeleteIcon } from '@vlabs/icons';
import { Control } from '@vlabs/uikit';

import { buildTestid } from '../../../shared/lib/utils';
import type { DeleteFacesProps } from '../types';
import { deleteFacesHandler } from './deleteFacesHandler';

const displayName = 'DeleteFacesIconButton';
const testid = buildTestid(displayName);

function DeleteFacesIconButton({
  faceIds,
  className = undefined,
  shape = 'square',
  variant = 'outlined',
  'data-testid': dataTestId = undefined,
  ...props
}: DeleteFacesProps): React.JSX.Element {
  return (
    <Control.IconButton
      className={className}
      data-testid={dataTestId}
      icon={<DeleteIcon />}
      kind="negative"
      shape={shape}
      size="small"
      variant={variant}
      {...testid(dataTestId)}
      {...props}
      onClick={deleteFacesHandler(faceIds)}
    />
  );
}

DeleteFacesIconButton.displayName = displayName;

export { DeleteFacesIconButton };
